import { useEffect as e, useRef as t } from "react";
//#region third-party/admiral-cmp/AdmiralCmp.tsx
var n = ({ admiralUrl: n, enabled: r }) => {
	let i = t(null);
	return e(() => {
		if (!r) return;
		let e = document.querySelector(`script[src="${n}"]`);
		if (e) {
			i.current = e;
			return;
		}
		let t = document.createElement("script");
		return t.src = n, t.dataset.admiralCmp = "true", document.head.prepend(t), i.current = t, () => {
			i.current && i.current.parentNode === document.head && document.head.removeChild(i.current), i.current = null;
		};
	}, [r, n]), null;
};
//#endregion
export { n as AdmiralCmp };
